import { reject, get, has, find } from 'lodash';
import { connect } from 'react-redux';

import CollectionDeadEnd from 'components/CollectionDeadEnd';
import { BREADCRUMB_NAVIGATION_LINK_TYPES } from 'constants/breadcrumbNavigation';
import * as actions from 'state/actions';
import Catalog from 'state/selectors/catalog';
import CollectionPage from 'state/selectors/collection-page';
import BreadcrumbsUtil from 'utils/Breadcrumbs';
import I18n from 'utils/I18n';
import Rudderstack from 'utils/Rudderstack';

const mapStateToProps = state => {
  const type = BREADCRUMB_NAVIGATION_LINK_TYPES.COLLECTION;
  const handle = CollectionPage.getCollectionHandle(state);

  const { secondaryNavigationOptions } = BreadcrumbsUtil.getSecondaryNavigationOptions({
    type,
    handle,
  });

  const { breadcrumbTrail } = BreadcrumbsUtil.getBreadcrumbTrail({ type, handle });

  // We are grabbing the top level collection label from the breadcrumbs
  const currentCollectionTitle = get(
    find(breadcrumbTrail, { type: BREADCRUMB_NAVIGATION_LINK_TYPES.COLLECTION }),
    'label'
  );

  let filteredSecondareNavigationOptions = reject(secondaryNavigationOptions, navOption => {
    return get(navOption, 'handle') === handle || !has(navOption, 'image');
  });

  if (filteredSecondareNavigationOptions.length % 2 === 1) {
    filteredSecondareNavigationOptions = filteredSecondareNavigationOptions.slice(
      0,
      filteredSecondareNavigationOptions.length - 1
    );
  } // We want to prevent overhang so we grab an even amount of nav

  const exploreMoreTitle = I18n.localize('collectionPage.deadEnd.exploreMore', {
    collectionLabel: currentCollectionTitle,
  });

  const is3Column = filteredSecondareNavigationOptions.length % 3 === 0;

  const currentCollection = {
    collection_handle: handle,
    collection_name: find(breadcrumbTrail, { handle: handle })?.label,
    collection_url: window.location.href,
    list_id: Catalog.getParentCollection(state, handle)?.id,
  };

  return {
    filteredSecondareNavigationOptions,
    is3Column,
    currentCollection,
    exploreMoreTitle,
  };
};

const mapDispatchToProps = dispatch => ({
  trackNavigation: (url, text, currentCollection) => {
    Rudderstack.productListFeatureClicked({
      featureCTA: text,
      featureLinkDestination: url,
      featureType: 'COLLECTION_NO_DEAD_ENDS',
      collection: currentCollection,
    });
    dispatch(actions.trackSecondaryNavigationNavigation(url));
    // Because this function will be added to an <a> tag's onClick handler, it needs to return true to not prevent navigation
    return true;
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CollectionDeadEnd);
